import { ZonesAndSubZones } from "../constants/action-constants/ZonesAndSubZonesActionConstants";

const initialState = {
  // Zones
  zones: [],
  zonesPagination: {},
  zonesLoading: false,
  zonesError: "",

  // create
  createZoneLoading: false,
  createZoneError: "",

  // update
  updateZoneLoadingMap: {},
  updateZoneError: "",

  // delete
  deleteZoneLoadingMap: false,
  deleteZoneError: "",

  // zone form
  openCreateAndUpdateZoneModal: false,
  zoneProcessDataObj: {},

  // Selected Region and Zones Map
  selectedRegionAndZonesMap: {},

  // get sub zones
  getSubZonesLoading: false,
  subZones: [],
  subZonesPagination: {},
  frequentlyOptedLocations: [],
  getSubZonesError: "",

  // create sub zones
  createSubZonesLoading: false,
  createSubZonesError: "",

  // update sub zones
  updateSubZonesLoading: false,
  updateSubZonesError: "",

  // delete sub zones
  deleteSubZonesLoading: false,
  deleteSubZonesError: "",

  // from
  openCreateAndUpdateSubZonesModal: false,
  subZonesProcessDataObj: {},
};

// remove keys from object whose values is empty array
function filterRegionAndZonesMap(regionAndZonesMap = {}) {
  const filteredMap = Object.keys(regionAndZonesMap)
    .filter(
      (key) =>
        Array.isArray(regionAndZonesMap[key]) &&
        regionAndZonesMap[key].length != 0
    )
    .reduce((acc, key) => {
      acc[key] = regionAndZonesMap[key];
      return acc;
    }, {});

  return filteredMap;
}

// update Region, Zones And SubZones Map
function updateRegionAndZonesAndSubZonesMap(
  regionAndZonesMap = {},
  zone = {},
  isSelect = true // key used for "select = true" & "unselect = false"
) {
  const { cityId, zoneId } = zone || {};

  const clonedRegionAndZonesMap = { ...regionAndZonesMap };
  const existingRegionIds = Object.keys(clonedRegionAndZonesMap);

  // append region in map
  if (!existingRegionIds.includes(cityId)) {
    clonedRegionAndZonesMap[cityId] = [];
  }

  const selectedRegionToAddOrRemoveZone = clonedRegionAndZonesMap[cityId] || [];
  const clonedSelectedRegionToAddOrRemoveZone = [
    ...selectedRegionToAddOrRemoveZone,
  ];
  const existingZoneIds = clonedSelectedRegionToAddOrRemoveZone.map(
    (zone) => zone.zoneId
  );
  const isZoneAlreadyPresent = existingZoneIds.includes(zoneId);

  const zoneIndex = clonedSelectedRegionToAddOrRemoveZone.findIndex(
    (zone) => zone.zoneId === zoneId
  );

  // update zones for "Select"
  if (isSelect) {
    // if zone not present then add the zone else update the zone
    if (!isZoneAlreadyPresent) {
      clonedSelectedRegionToAddOrRemoveZone.push(zone);
    } else {
      clonedSelectedRegionToAddOrRemoveZone[zoneIndex] = zone;
    }

    clonedRegionAndZonesMap[cityId] = clonedSelectedRegionToAddOrRemoveZone;
  }

  // update zones for "Un Select"
  if (!isSelect) {
    // only splice array when item is found
    if (zoneIndex > -1) {
      clonedSelectedRegionToAddOrRemoveZone.splice(zoneIndex, 1);
    }

    // update after removing zone
    clonedRegionAndZonesMap[cityId] = clonedSelectedRegionToAddOrRemoveZone;
  }

  // filter map by removing regions with no zones
  const filteredRegionsAndZonesMap = filterRegionAndZonesMap(
    clonedRegionAndZonesMap
  );

  // final return
  return filteredRegionsAndZonesMap;
}

// constructFreqOptLocations
function constructFreqOptLocations(subZones = []) {
  if (!subZones || subZones.length === 0) {
    return [];
  }

  const frqOptLocations = subZones.flatMap((zone) => {
    const { subZoneNames = [], zoneId, zoneName } = zone;
    return subZoneNames.map((subZoneName) => {
      return {
        subZoneName,
        percentage: 6,
        zoneId,
        zoneName,
      };
    });
  });

  return frqOptLocations;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ZonesAndSubZones.GET_ZONES:
      return {
        ...state,
        zonesLoading: true,
        zones: [],
        zonesPagination: {},
      };

    case ZonesAndSubZones.GET_ZONES_SUCCESS: {
      const { zones, pagination } = action.payload;
      return {
        ...state,
        zonesLoading: false,
        zones,
        zonesPagination: pagination,
      };
    }

    case ZonesAndSubZones.GET_ZONES_FAILURE:
      return {
        ...state,
        zonesLoading: false,
        zonesError: action.payload,
      };

    case ZonesAndSubZones.CLEAR_ZONES: {
      return {
        ...state,
        zonesLoading: false,
        zones: [],
        zonesPagination: {},
      };
    }

    // create zone
    case ZonesAndSubZones.CREATE_ZONE:
      return {
        ...state,
        createZoneLoading: true,
      };

    case ZonesAndSubZones.CREATE_ZONE_SUCCESS: {
      return {
        ...state,
        createZoneLoading: false,
      };
    }

    case ZonesAndSubZones.CREATE_ZONE_FAILURE:
      return {
        ...state,
        createZoneLoading: false,
        createZoneError: action.payload,
      };

    // update zone
    case ZonesAndSubZones.UPDATE_ZONE: {
      const { regionId } = action.payload || {};
      return {
        ...state,
        updateZoneLoadingMap: {
          ...state.updateZoneLoadingMap,
          [regionId]: true,
        },
      };
    }

    case ZonesAndSubZones.UPDATE_ZONE_SUCCESS: {
      const { regionId } = action.payload || {};

      return {
        ...state,
        updateZoneLoadingMap: {
          ...state.updateZoneLoadingMap,
          [regionId]: false,
        },
      };
    }

    case ZonesAndSubZones.UPDATE_ZONE_FAILURE: {
      const { regionId, error } = action.payload || {};
      return {
        ...state,
        updateZoneLoadingMap: {
          ...state.updateZoneLoadingMap,
          [regionId]: false,
        },
        updateZoneError: error,
      };
    }

    // delete zone
    case ZonesAndSubZones.DELETE_ZONE: {
      const { regionId } = action.payload || {};
      return {
        ...state,
        deleteZoneLoadingMap: {
          ...state.deleteZoneLoadingMap,
          [regionId]: true,
        },
      };
    }

    case ZonesAndSubZones.DELETE_ZONE_SUCCESS: {
      const { regionId } = action.payload || {};
      return {
        ...state,
        deleteZoneLoadingMap: {
          ...state.deleteZoneLoadingMap,
          [regionId]: false,
        },
      };
    }

    case ZonesAndSubZones.DELETE_ZONE_FAILURE: {
      const { regionId, error } = action.payload || {};
      return {
        ...state,
        deleteZoneLoadingMap: {
          ...state.deleteZoneLoadingMap,
          [regionId]: false,
        },
        deleteZoneError: error,
      };
    }

    // zone form
    case ZonesAndSubZones.OPEN_CREATE_AND_UPDATE_ZONE_MODAL: {
      return {
        ...state,
        openCreateAndUpdateZoneModal: true,
        zoneProcessDataObj: action.payload || {},
      };
    }

    case ZonesAndSubZones.CLOSE_CREATE_AND_UPDATE_ZONE_MODAL:
      return {
        ...state,
        openCreateAndUpdateZoneModal: false,
        zonesProcessDataObj: {},
      };

    // Select & unSelect Zone
    case ZonesAndSubZones.SELECT_ZONE: {
      const { zone } = action.payload;

      const updatedRegionAndZonesMap = updateRegionAndZonesAndSubZonesMap(
        state.selectedRegionAndZonesMap,
        zone,
        true
      );

      return {
        ...state,
        selectedRegionAndZonesMap: updatedRegionAndZonesMap,
      };
    }

    case ZonesAndSubZones.UN_SELECT_ZONE: {
      const { zone } = action.payload;

      const updatedRegionAndZonesMap = updateRegionAndZonesAndSubZonesMap(
        state.selectedRegionAndZonesMap,
        zone,
        false
      );

      return {
        ...state,
        selectedRegionAndZonesMap: updatedRegionAndZonesMap,
      };
    }

    // clear selected Region & Zones map
    case ZonesAndSubZones.CLEAR_SELECTED_REGION_AND_ZONES_MAP: {
      return {
        ...state,
        selectedRegionAndZonesMap: {},
        zones: [],
        frequentlyOptedLocations: [],
      };
    }

    // get sub zones
    case ZonesAndSubZones.GET_SUB_ZONES:
      return {
        ...state,
        getSubZonesLoading: true,
      };

    case ZonesAndSubZones.GET_SUB_ZONES_SUCCESS: {
      const { subZones, pagination } = action.payload;

      // frequently opted locations
      const frequentlyOptedLocations = constructFreqOptLocations(subZones);

      return {
        ...state,
        getSubZonesLoading: false,
        subZones,
        subZonesPagination: pagination,
        frequentlyOptedLocations,
      };
    }

    case ZonesAndSubZones.GET_SUB_ZONES_FAILURE:
      return {
        ...state,
        getSubZonesLoading: false,
        getSubZonesError: action.payload,
      };

    case ZonesAndSubZones.CLEAR_SUB_ZONES: {
      return {
        ...state,
        subZones: [],
        subZonesPagination: {},
        frequentlyOptedLocations: [],
      };
    }

    // create sub zones
    // -------------------------------------------------------------
    case ZonesAndSubZones.CREATE_SUB_ZONES:
      return {
        ...state,
        createSubZonesLoading: true,
      };

    case ZonesAndSubZones.CREATE_SUB_ZONES_SUCCESS: {
      return {
        ...state,
        createSubZonesLoading: false,
      };
    }

    case ZonesAndSubZones.CREATE_SUB_ZONES_FAILURE:
      return {
        ...state,
        createSubZonesLoading: false,
        createSubZonesError: action.payload,
      };

    // update sub zones
    // -------------------------------------------------------------
    case ZonesAndSubZones.UPDATE_SUB_ZONES:
      return {
        ...state,
        updateSubZonesLoading: true,
      };

    case ZonesAndSubZones.UPDATE_SUB_ZONES_SUCCESS: {
      return {
        ...state,
        updateSubZonesLoading: false,
      };
    }

    case ZonesAndSubZones.UPDATE_SUB_ZONES_FAILURE:
      return {
        ...state,
        updateSubZonesLoading: false,
        updateSubZonesError: action.payload,
      };

    // delete sub zones
    // -------------------------------------------------------------
    case ZonesAndSubZones.DELETE_SUB_ZONES:
      return {
        ...state,
        deleteSubZonesLoading: true,
      };

    case ZonesAndSubZones.DELETE_SUB_ZONES_SUCCESS: {
      return {
        ...state,
        deleteSubZonesLoading: false,
      };
    }

    case ZonesAndSubZones.DELETE_SUB_ZONES_FAILURE:
      return {
        ...state,
        deleteSubZonesLoading: false,
        deleteSubZonesError: action.payload,
      };

    case ZonesAndSubZones.OPEN_CREATE_AND_UPDATE_SUB_ZONES_MODAL: {
      return {
        ...state,
        openCreateAndUpdateSubZonesModal: true,
        subZonesProcessDataObj: action.payload || {},
      };
    }

    case ZonesAndSubZones.CLOSE_CREATE_AND_UPDATE_SUB_ZONES_MODAL:
      return {
        ...state,
        openCreateAndUpdateSubZonesModal: false,
        subZonesProcessDataObj: {},
      };

    default:
      return state;
  }
};
